import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-600eae02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "compare-table" }
const _hoisted_2 = { class: "mb--20" }
const _hoisted_3 = { class: "compare-table__img-box" }
const _hoisted_4 = { class: "compare-table__img-box-img" }
const _hoisted_5 = { class: "compare-table__img-box-delete-icon" }
const _hoisted_6 = { class: "compare-table__info-box items-in-column gap--5 mt--10" }
const _hoisted_7 = { class: "medium" }
const _hoisted_8 = { class: "compare-table__info-box-address" }
const _hoisted_9 = { class: "compare-table__activities-box" }
const _hoisted_10 = { class: "items-in-column gap--10" }
const _hoisted_11 = { class: "items-in-column gap--10" }
const _hoisted_12 = {
  key: 0,
  class: "compare-table__top-small-block"
}
const _hoisted_13 = { class: "flex gap--10" }
const _hoisted_14 = { class: "compare-table__top-small-block-img" }
const _hoisted_15 = { class: "items-in-column gap--5" }
const _hoisted_16 = { class: "compare-table__top-small-block-title" }
const _hoisted_17 = { class: "third-color compare-table__top-small-block-info" }
const _hoisted_18 = { class: "items-in-line none-Mobile" }
const _hoisted_19 = { class: "compare-table__main-block-container" }
const _hoisted_20 = { class: "m-font-size medium" }
const _hoisted_21 = { class: "mb--20" }
const _hoisted_22 = { class: "third-color compare-table__param-title" }
const _hoisted_23 = { class: "compare-table__param-value" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { key: 2 }
const _hoisted_28 = { key: 3 }
const _hoisted_29 = {
  key: 1,
  class: "four-color"
}

import { ResultCardType } from '@/types';
import { ref, watch } from 'vue';
import { MapBlock, PhoneButton, ShareBtn } from '@/components';
import { useElementVisibility } from '@vueuse/core';
import { useUserStore } from '@/store/modules/user';
import { useChatStore } from '@/store/modules/chat';
import { useAppStore } from '@/store/modules/app';

type CategoryType = {
  title: string;
  params: {
    paramTitle: string;
    key: string;
    type?: 'number' | 'map' | 'classifier';
  }[];
};


export default /*#__PURE__*/_defineComponent({
  __name: 'CompareTable',
  props: {
    offerCards: {}
  },
  setup(__props: any) {

const props = __props;
const topBlock = ref<HTMLInputElement>();
const contentBlock = ref<HTMLInputElement>();
const smallTopBlock = ref<HTMLInputElement>();

const isVisible = useElementVisibility(topBlock);

const scrollBlock = (block: HTMLInputElement | undefined) => {
  if (block) {
    const scrollSize: number = block.scrollLeft;

    const contentBlockValue = contentBlock.value;
    const smallTopBlockValue = smallTopBlock.value;
    const topBlockValue = topBlock.value;

    if (contentBlockValue) {
      contentBlockValue.scrollLeft = scrollSize;
    }
    if (smallTopBlockValue) {
      smallTopBlockValue.scrollLeft = scrollSize;
    }
    if (topBlockValue) {
      topBlockValue.scrollLeft = scrollSize;
    }
  }
};

const categories: CategoryType[] = [
  {
    title: 'Основная информация',
    params: [
      {
        paramTitle: 'Цена, ₽',
        key: 'price',
        type: 'number',
      },
      {
        paramTitle: 'Этаж',
        key: 'floor',
      },
      {
        paramTitle: 'Классификатор',
        type: 'classifier',
        key: 'rating',
      },
    ],
  },
  {
    title: 'Информация о доме',
    params: [
      {
        paramTitle: 'Площадь, м²',
        key: 'houseArea',
      },
    ],
  },
  {
    title: 'Информация о земле',
    params: [
      {
        paramTitle: 'Участок, сот.',
        key: 'landArea',
      },
      {
        paramTitle: 'Тип',
        key: 'type',
      },
    ],
  },
  {
    title: 'Расположение',
    params: [
      {
        paramTitle: 'Адрес',
        key: 'address',
      },
      {
        paramTitle: 'На карте',
        key: 'coordinates',
        type: 'map',
      },
    ],
  },
];

watch(
  () => smallTopBlock.value,
  () => {
    scrollBlock(contentBlock.value);
  },
);

return (_ctx: any,_cache: any) => {
  const _component_base_image = _resolveComponent("base-image")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_icon = _resolveComponent("base-icon")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_rating_number = _resolveComponent("base-rating-number")!
  const _component_base_expansion_panels = _resolveComponent("base-expansion-panels")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "topBlock",
      ref: topBlock,
      class: "compare-table__main-block topBlock",
      onScroll: _cache[0] || (_cache[0] = ($event: any) => (scrollBlock(topBlock.value)))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.offerCards, (card) => {
        return (_openBlock(), _createElementBlock("div", {
          key: card.id,
          class: "compare-table__one-card"
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_router_link, {
                    to: { name: 'offerCard', params: { url: card.landUrl } }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_base_image, {
                        name: String(card.id),
                        src: card.img ? card.img[0] : undefined,
                        borderRadius: "",
                        cover: "",
                        height: "100%",
                        version: "x1",
                        width: "100%"
                      }, null, 8, ["name", "src"])
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_base_button, {
                    icon: "",
                    "style-type": "translucent",
                    withoutActive: "",
                    onClick: ($event: any) => (_ctx.$emit('changeIsCompare', card))
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_base_icon, {
                        color: "#ffffff",
                        "font-size": "20",
                        name: "delete"
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(card.price ? card.price?.toLocaleString() : '-') + " ₽ ", 1),
                _createElementVNode("div", _hoisted_8, _toDisplayString(card.address), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_unref(PhoneButton), {
                  phone: card.phone,
                  "phone-modal": _unref(useAppStore)().getWindowWidth() <= 600,
                  height: "36"
                }, null, 8, ["phone", "phone-modal"]),
                _createVNode(_component_base_button, {
                  "all-block-width": "",
                  class: "active-card__infoBlock-chat",
                  height: "36",
                  "style-type": "coloredBorder",
                  text: "Написать",
                  onClick: ($event: any) => (_unref(useChatStore)().openMiniMessenger(card))
                }, null, 8, ["onClick"])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_base_button, {
                    height: "36",
                    icon: "",
                    "style-type": "border",
                    width: "36",
                    withoutActive: "",
                    onClick: ($event: any) => (_ctx.$emit('changeIsFavorite', card.landId))
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_base_icon, {
                        color: 
                        _unref(useUserStore)().getIsFavorite(card.landId) ? '#EA1F1F' : '#969696'
                      ,
                        "font-size": "20",
                        name: "favorite",
                        width: "36"
                      }, null, 8, ["color"])
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_unref(ShareBtn), {
                    disabled: !card.landUrl,
                    link: `${_unref(useAppStore)().baseUrl}/offerCard/${card.landUrl}`,
                    color: "#009D3E",
                    "font-size": "20",
                    height: "36",
                    width: "36"
                  }, null, 8, ["disabled", "link"])
                ])
              ])
            ])
          ])
        ]))
      }), 128))
    ], 544),
    (!_unref(isVisible))
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", {
            ref_key: "smallTopBlock",
            ref: smallTopBlock,
            class: "container compare-table__main-block smallTopBlock",
            onScroll: _cache[1] || (_cache[1] = ($event: any) => (scrollBlock(smallTopBlock.value)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.offerCards, (card) => {
              return (_openBlock(), _createElementBlock("div", {
                key: card.id,
                class: "compare-table__one-card"
              }, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_router_link, {
                      to: { name: 'offerCard', params: { url: card.landUrl } }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_base_image, {
                          name: String(card.id),
                          src: card.img ? card.img[0] : undefined,
                          borderRadius: "",
                          cover: "",
                          height: "100%",
                          width: "100%"
                        }, null, 8, ["name", "src"])
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, _toDisplayString(card.price?.toLocaleString()) + " ₽ ", 1),
                    _createElementVNode("div", _hoisted_17, _toDisplayString(card.address), 1),
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_unref(PhoneButton), {
                        phone: card.phone,
                        height: "30",
                        "phone-modal": ""
                      }, null, 8, ["phone"]),
                      _createVNode(_component_base_button, {
                        height: "30",
                        "style-type": "coloredBorder",
                        text: "Чат",
                        onClick: ($event: any) => (_unref(useChatStore)().openMiniMessenger(card))
                      }, null, 8, ["onClick"])
                    ])
                  ])
                ])
              ]))
            }), 128))
          ], 544)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      ref_key: "contentBlock",
      ref: contentBlock,
      class: "compare-table__main-block contentBlock",
      onScroll: _cache[2] || (_cache[2] = ($event: any) => (scrollBlock(contentBlock.value)))
    }, [
      _createElementVNode("div", _hoisted_19, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(categories, (item, i) => {
          return _createVNode(_component_base_expansion_panels, {
            key: i,
            "is-open": true,
            isMobileCollapse: "",
            styleType: "with-line"
          }, {
            title: _withCtx((titleProps) => [
              _createElementVNode("span", _hoisted_20, _toDisplayString(item.title), 1)
            ]),
            content: _withCtx((contentProps) => [
              _createElementVNode("div", _hoisted_21, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.params, (param, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i,
                    class: "compare-table__param"
                  }, [
                    _createElementVNode("div", _hoisted_22, _toDisplayString(param.paramTitle), 1),
                    _createElementVNode("div", _hoisted_23, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.offerCards, (card) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: card.id,
                          class: "compare-table__one-card"
                        }, [
                          (card[param.key as keyof typeof card] !== undefined)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                                (param.type === 'number')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(card[param.key as keyof typeof card]?.toLocaleString()), 1))
                                  : (param.type === 'map')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                                        _createVNode(_unref(MapBlock), {
                                          "center-point-map": card[param.key as keyof typeof card],
                                          "result-cards-coordinates": [
                            {
                              id: card.id,
                              coordinates: card[param.key as keyof typeof card],
                            },
                          ],
                                          zoom: 12,
                                          height: "200"
                                        }, null, 8, ["center-point-map", "result-cards-coordinates"])
                                      ]))
                                    : (param.type === 'classifier')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_27, [
                                          _createVNode(_component_base_rating_number, {
                                            "max-rate": card.classifier?.maxRate,
                                            rating: card.rating
                                          }, null, 8, ["max-rate", "rating"])
                                        ]))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(card[param.key as keyof typeof card]), 1))
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_29, "не указано"))
                        ]))
                      }), 128))
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _: 2
          }, 1024)
        }), 64))
      ])
    ], 544)
  ]))
}
}

})